import React from 'react';
import ReactDOM from 'react-dom/client';

import "./styles/sass/custom.scss";
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min";
import "aos/dist/aos.css";
// import "https://unpkg.com/@dotlottie/player-component@2.7.12/dist/dotlottie-player.mjs";
import '@dotlottie/player-component';



// Import App and reportWebVitals
import App from './App';
import reportWebVitals from './reportWebVitals';
// import reportWebVitals from './reportWebVitals.js';


// Initialize AOS with "once: true"
// AOS.init({
//   once: true, // Ensures the animation runs only once
// });



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  // <React.StrictMode>
    <App />
  //</React.StrictMode>
);

// If you want to start measuring performance in your app
reportWebVitals();
